import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { reservationKeys, reservationOptions } from '../../constants/reservations';
const LIVE_POLL_INTERVAL_MILLISECONDS = 3_000;
const isAwaitingConfirmation = (reservation) => reservation.status === 'pending';
const getLiveRefetchInterval = (reservations) => {
    if (!reservations || reservations.length === 0)
        return false;
    return reservations.some(isAwaitingConfirmation) ? LIVE_POLL_INTERVAL_MILLISECONDS : false;
};
const getReservationDeadline = (reservation) => isAwaitingConfirmation(reservation) ? reservation.expiresAt?.getTime() : reservation.endAt.getTime();
const getNextScheduledExpiryTime = (reservations, now) => {
    const futureExpiryTimes = reservations
        .map(getReservationDeadline)
        .filter((expiryTime) => expiryTime !== undefined && expiryTime > now);
    return futureExpiryTimes.length > 0 ? Math.min(...futureExpiryTimes) : undefined;
};
export function useReservationsLive(filter, scope) {
    const queryClient = useQueryClient();
    const { data, isLoading, isSuccess } = useQuery(reservationOptions.get(filter, scope, {
        refetchInterval: getLiveRefetchInterval,
    }));
    useEffect(() => {
        if (!data)
            return;
        const nextExpiryTime = getNextScheduledExpiryTime(data, Date.now());
        if (nextExpiryTime === undefined)
            return;
        const timeout = setTimeout(() => {
            queryClient.invalidateQueries({ queryKey: reservationKeys.all });
        }, nextExpiryTime - Date.now());
        return () => clearTimeout(timeout);
    }, [data, queryClient]);
    return {
        reservations: data ?? [],
        loadingReservations: isLoading,
        isSuccess,
    };
}
